import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';

import { MatDialog } from '@angular/material/dialog';
import { AcessosUsuariosElement } from '../../interfaces/acessos.usuarios';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';

import { ExcelService } from '../../services/excel.service';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'


@Component({
  selector: 'app-relatorio-acessos',
  templateUrl: './relatorio-acessos.component.html',
  styleUrls: ['./relatorio-acessos.component.scss', '../../styles/estilo.padrao.scss']
})
export class RelatorioAcessosComponent implements OnInit {
  uid;
  bConsulta: boolean = false;
  range: FormGroup;
  datePickerRotaControl: FormControl;

  auxUsuarios: AcessosUsuariosElement[] = [];

  sbBuscaStatusUsuario: string | boolean = 'Todos';
  aTipoStatusUsuario: any[] = [
    { value: 'Todos', name: 'Todos' },
    { value: true, name: 'Ativo' },
    { value: false, name: 'Desativado' },
  ];

  sBuscaCidade: string = 'Todas';
  aTodasCidades: any[] = [];
  aCidades: any[] = [];

  sBuscaUF: string;
  aUFs: any[] = [];

  sBuscaVendedor: string = 'Todos';
  aVendedores: any[] = [];
  contTotalAcessos: number = 0;

  maxDate: Date = new Date();
  minDate: Date = new Date();

  $pedidos;

  tipoCadastro = 'Vendedor';

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private excelService: ExcelService,
    private af: AngularFireAuth

  ) {
    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });

    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear, 0, 1);
  }

  ngOnInit(): void {
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });

    this.datePickerRotaControl = new FormControl(new Date());

    this.range.get('start').patchValue(new Date());
    this.range.get('end').patchValue(new Date());

    //Recupera os funcionários / Vendedores
    this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
      this.aVendedores = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.Status && dados.Permissoes.Vender) {
            this.aVendedores.push({
              value: item.key,
              name: dados.Nome,
            });
          }
        });

        //Ordena alfabeticamente
        this.aVendedores.sort((a, b) => a.value.localeCompare(b.value));

        this.aVendedores.unshift({ value: 'Todos', name: 'Todos' });

        if (this.tipoCadastro === 'Vendedor') {
          this.sBuscaVendedor = this.uid;
        }
      }
    });

    this.usuarioService.getCidades(this.uid).pipe(take(1)).subscribe(snap => {
      this.aCidades = [];
      let auxIndex;

      if (snap.length > 0) {
        var dados;
        var auxDadosCidade;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          auxIndex = this.aUFs.findIndex(x => x.value === item.key);

          if (auxIndex === -1) {
            this.aUFs.push({
              value: item.key,
              name: item.key,
            });
          }

          Object.keys(dados).forEach((key, index) => {
            auxDadosCidade = dados[key];
            if (auxDadosCidade.Status) {
              this.aTodasCidades.push({
                uf: item.key,
                value: auxDadosCidade.Cidade,
                name: auxDadosCidade.Cidade
              })
            }
          });


        });

        this.aUFs.sort((a, b) => a.name.localeCompare(b.name));
        this.aTodasCidades.sort((a, b) => a.name.localeCompare(b.name));

        this.sBuscaUF = 'MG';
        this.carregarCidades();
      }
    });
  }

  carregarCidades() {
    this.aCidades = [];
    for (let i = 0; i < this.aTodasCidades.length; i++) {
      if (this.aTodasCidades[i].uf === this.sBuscaUF) {
        this.aCidades.push({
          uf: this.aTodasCidades[i].key,
          value: this.aTodasCidades[i].value,
          name: this.aTodasCidades[i].name
        });
      }
    }

    this.aCidades.sort((a, b) => a.name.localeCompare(b.name));

    this.aCidades.unshift({
      uf: null,
      value: 'Todas',
      name: 'Todas'
    });

    this.sBuscaCidade = 'Todas';
  }

  buscarAcessoUsuarios() {

    this.spinner.show('relatorio-acessos');
    let timestampInicio: Date = new Date(this.range.get('start').value);
    timestampInicio.setHours(0);
    timestampInicio.setMinutes(0);
    timestampInicio.setSeconds(0);
    timestampInicio.setMilliseconds(0);

    let timestampFinal: Date = new Date(this.range.get('end').value);
    timestampFinal.setHours(23);
    timestampFinal.setMinutes(59);
    timestampFinal.setSeconds(59);
    timestampFinal.setMilliseconds(999);
    var difference = (timestampInicio.getFullYear() * 12 + timestampInicio.getMonth()) - (timestampFinal.getFullYear() * 12 + timestampFinal.getMonth());

    if (difference >= -12) {
      this.$pedidos = this.usuarioService.getAcessosTimestamp(timestampInicio.getTime(), timestampFinal.getTime()).pipe(take(1)).subscribe(snap => {

        if (snap.length > 0) {
          this.auxUsuarios = [];
          this.contTotalAcessos = 0;

          var dados;

          snap.forEach((item, index) => {
            dados = item.payload.val();

            if (
              (this.validarFiltro('Status do usuário', dados.Status, null)) &&
              (this.validarFiltro('Vendedor', dados.IDVendedor, null)) &&
              (this.validarFiltro('Cidade', dados.Cidade, dados.UF))
            ) {
              this.auxUsuarios.push({
                ID: item.key,
                Bairro: dados.Bairro,
                Cidade: dados.Cidade,
                Email: dados.Email,
                IDVendedor: dados.IDVendedor,
                Logradouro: dados.Logradouro,
                Nome: dados.Nome,
                Numero: dados.Numero,
                Referencia: dados.Referencia,
                Status: dados.Status,
                StatusString: dados.Status ? 'Ativo' : 'Desativado',
                Telefone: dados.Telefone,
                TelefoneSecundario: dados.TelefoneSecundario,
                UF: dados.UF,
                Data: this.usuarioService.tratarData(dados.Timestamp),
                Hora: this.usuarioService.tratarHora(dados.Timestamp),
                NomeVendedor: this.aVendedores[this.aVendedores.findIndex(x => x.value === dados.IDVendedor)] ? this.aVendedores[this.aVendedores.findIndex(x => x.value === dados.IDVendedor)].name : '-',
                TipoAcesso: dados.TipoAcesso,
                PlataformaAcesso: dados.PlataformaAcesso
              });

              this.contTotalAcessos++;
            }
          });
          // this.auxUsuarios = this.auxUsuarios.reverse();

          this.usuarioService.setLog("Consulta relatório de acessos: " + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);

          this.bConsulta = true;

          setTimeout(() => this.spinner.hide('relatorio-acessos'), 300);
        } else {
          this.toastr.error("Não foi possível localizar acessos!", 'Erro');
          setTimeout(() => this.spinner.hide('relatorio-acessos'), 300);
        }
      });
    } else {
      this.toastr.warning('Não é possível realizar um filtro acima de 12 meses!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('relatorio-acessos'), 300);
    }
  }

  validarFiltro(tipo, status, uf) {
    switch (tipo) {
      case 'Status do usuário':
        return this.sbBuscaStatusUsuario === 'Todos' ? true : status === this.sbBuscaStatusUsuario;

      case 'Vendedor':
        return this.sBuscaVendedor === 'Todos' ? true : status === this.sBuscaVendedor;

      case 'Cidade':
        return this.sBuscaCidade === 'Todas' ? uf === this.sBuscaUF ? true : false : status === this.sBuscaCidade && uf === this.sBuscaUF;

      default: return false;
    }
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: true, bCSV: true },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo)
      }
    });
  }

  imprimir(tipo) {
    var date = new Date();
    date.setTime(this.range.get('start').value);
    var dateFinal = new Date();
    dateFinal.setTime(this.range.get('end').value);

    switch (tipo) {
      //PDF
      case 0:
        let doc = new jsPDF('l', 'mm', [297, 210]);
        let corpo: any = [];
        this.auxUsuarios.forEach(dado => {
          var aux = [dado.Nome, dado.Bairro, dado.Cidade, dado.UF, dado.NomeVendedor, dado.PlataformaAcesso, dado.TipoAcesso, dado.Data, dado.Hora, dado.StatusString];
          corpo.push(aux);
        });

        autoTable(doc, {
          head: [["Nome", "Bairro", "Cidade", "UF", "Vendedor", "Plataforma", "Tipo", "Data", "Hora", "Status"]],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
          // foot: [["", "", "", "", "", "", "", "", "", "",]]
        });
        doc.save('Relatório_acessos_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()) + '.pdf');

        this.usuarioService.setLog("Exportou relatório de acessos em PDF. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), null, this.uid);
        break;

      //Excel
      case 1:
        this.excelService.exportAsExcelFile(this.auxUsuarios, 'Relatório_acessos_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()));

        this.usuarioService.setLog("Exportou relatório de acessos em EXCEL. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), null, this.uid);
        break;

      //CSV
      case 2:
        var options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'Relatório_acessos_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()),
          useBom: true,
          noDownload: false,
          headers: ["ID", "Bairro", "Cidade", "Email", "IDVendedor", "Logradouro", "Nome", "Numero", "Referencia", "Status", "StatusString", "Telefone", "TelefoneSecundario", "UF", "Data", "Hora", "NomeVendedor", "TipoAcesso", "PlataformaAcesso"],
          nullToEmptyString: true,
        };

        new Angular5Csv(this.auxUsuarios, 'Relatório_acessos_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), options);
        this.usuarioService.setLog("Exportou relatório de acessos em CSV. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), null, this.uid);

        break;
    }
  }

}
